'use memo'

import {
  buildApiDocsUrl,
  buildTokenApiBaseUrl,
  type AccountApiAccess,
} from '@sportninja/common/features/account/apiAccess'
import { useApiBaseUrl } from '../hooks/useApiBaseUrl'
import { ApiQuickStartSection } from './ApiQuickStartSection'
import { ApiTokensSection } from './ApiTokensSection'

interface ApiAccessProps {
  accountUid: string | undefined
  access: AccountApiAccess
}

/**
 * Account settings › API Access: the signed-in user's API tokens on top, then
 * how to use one, against the API this web app talks to.
 */
export const ApiAccess = ({ accountUid, access }: ApiAccessProps) => {
  const { apiBaseUrl } = useApiBaseUrl()

  if (!accountUid) {
    return null
  }

  const tokenApiBaseUrl = buildTokenApiBaseUrl(apiBaseUrl)

  return (
    <>
      <ApiTokensSection
        accountUid={accountUid}
        access={access}
        apiDocsUrl={buildApiDocsUrl(apiBaseUrl)}
      />
      {tokenApiBaseUrl ? (
        <ApiQuickStartSection tokenApiBaseUrl={tokenApiBaseUrl} />
      ) : null}
    </>
  )
}
